import script from "./BillingAutomationView.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingAutomationView.vue?vue&type=script&setup=true&lang=js"

import "./BillingAutomationView.vue?vue&type=style&index=0&id=039735f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-039735f4"]])

export default __exports__